import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Vendor } from '../vendor/vendor';
import { VendorService } from '../vendor/vendor.service';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-vendor-detail',
  templateUrl: './vendor-detail.component.html',
  styleUrls: ['./vendor-detail.component.css']
})
export class VendorDetailComponent implements OnInit {
  vendor: Vendor;
  msgs: Message[];
  private isEdit: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private vendorService: VendorService) {
    this.vendor = new Vendor();
    this.msgs = [];
    this.isEdit = false;
  }

  ngOnInit() {
    // Here we go, we need to check if there was an id passed. if so, we 
    // have to query vendor details to enable edit of vendor.
    if (this.route.snapshot.params['id'] != null) {
      this.vendorService.qryVendor(+this.route.snapshot.params['id']).subscribe(
        (vendor: Vendor) => {
          if (vendor != null) {
            this.vendor = vendor;
            this.isEdit = true;
          } else {
            this.msgs.push({ severity: 'warn', summary: 'Failed to load vendor.' });
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Failed to load vendor.' })
        }
      );
    }
  }


  /**
   * Saves vendor.
   */
  public onSubmit() {
    if (!this.isEdit) {
      this.vendorService.save(this.vendor).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lieferant wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/vendor');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lieferant konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save vendor, error msg: ' + err);
        }
      );
    }else{
      this.vendorService.update(this.vendor).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Lieferant wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/vendor');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Lieferant konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save vendor, error msg: ' + err);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor-detail/vendor-detail.component.ts